// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_add_to_cart_failed = /** @type {(inputs: {}) => string} */ () => {
	return `Failed to add to cart`
};

const el_add_to_cart_failed = /** @type {(inputs: {}) => string} */ () => {
	return `Αποτυχία προσθήκης`
};

const ru_add_to_cart_failed = /** @type {(inputs: {}) => string} */ () => {
	return `Ошибка добавления`
};

const he_add_to_cart_failed = /** @type {(inputs: {}) => string} */ () => {
	return `ההוספה נכשלה`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const add_to_cart_failed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.add_to_cart_failed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("add_to_cart_failed", locale)
	if (locale === "en") return en_add_to_cart_failed(inputs)
	if (locale === "el") return el_add_to_cart_failed(inputs)
	if (locale === "ru") return ru_add_to_cart_failed(inputs)
	if (locale === "he") return he_add_to_cart_failed(inputs)
	return "add_to_cart_failed"
};